// ClientLandingPage.jsx
export default function ClientLandingPage() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
      <div className="card shadow-lg p-5 text-center" style={{ maxWidth: "500px" }}>
        <h2 className="mb-3 text-primary">Onboarding Completed ✅</h2>
        <p className="lead text-muted mb-4">
          Your onboarding is complete!  
          The Client Dashboard is under development.
        </p>
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-secondary">
          Please check back soon for updates.
        </p>
      </div>
    </div>
  );
}
